export class MSocketHandle {
  setting = {
    events: {
      join: 'join',
      leave: 'leave',
      member: 'on-room',
    },
  }

  /**
   *
   * current client connection
   *
   *@type {SocketIOClient.Socket}
   */
  current

  /**
   * setCurrent socket connection
   *
   * @date 2022-10-05
   * @param {SocketIOClient.Socket} socket
   */
  setHandler(socket) {
    this.current = socket
  }

  /**
   * return current socket id
   *
   * @returns {number}
   * @memberof MSocketHandle
   */
  getID() {
    return this.current && this.current.id
  }

  /**
   * return current socket connection
   *
   * @memberof MSocketHandle
   * @returns {SocketIOClient.Socket}
   */
  getConnection() {
    return this.current
  }

  /**
   *
   * Adds a listener for a particular event. Calling multiple times will add multiple listeners
   *
   * @date 2022-10-05
   * @param {string} event The event that we're listening for
   * @param {function} callback The function to call when we get the event. Parameters depend on the event in question
   * @returns
   */
  on(event, callback) {
    this.current && this.current.on(event, callback)
    return this
  }

  /**
   * Removes a listener for a particular type of event. This will either remove a specific listener, or all listeners for this type of event
   *
   * @date 2022-10-05
   * @param {*} event The event that we're listening for
   * @param {function} callback The function to call when we get the event. Parameters depend on the event in question
   * @returns
   */
  off(event, callback) {
    this.current && this.current.off(event, callback)
    return this
  }

  /**
   * Adds a listener for a particular event that will be invoked a single time before being automatically removed
   *
   * @date 2022-10-05
   * @param {string} event The event that we're listening for
   * @param {function} callback The function to call when we get the event. Parameters depend on the event in question
   */
  once(event, callback) {
    this.current && this.current.once(event, callback)
    return this
  }

  /**
   * An override of the base emit.
   * If the event is one of: connect connect_error connect_timeout connecting disconnect error reconnect reconnect_attempt reconnect_failed reconnect_error reconnecting ping pong then the event is emitted normally.
   * Otherwise, if we're connected, the event is sent. Otherwise, it's buffered.
   * If the last argument is a function, then it will be called as an 'ack' when the response is received. The parameter(s) of the ack will be whatever data is returned from the event
   *
   * @date 2022-10-05
   * @param {string} event
   * @param {*} args
   */
  emit(event, ...args) {
    this.current && this.current.emit(event, ...args)
    return this
  }

  /**
   * he event that we're looking for the callbacks of
   * Returns all the callbacks for a particular event
   *
   * @date 2022-10-05
   * @param {string} event
   * @return {function[]} An array of callback Functions, or an empty array if we don't have any
   */
  listeners(event) {
    return this.current ? this.current.listeners(event) : []
  }

  /**
   * Returns if we have listeners for a particular event
   *
   * @date 2022-10-05
   * @param {string} event
   */
  hasListeners(event) {
    return this.current ? this.current.hasListeners(event) : false
  }

  /**
   * join event channel
   *
   * @date 2022-10-05
   * @param {object} room
   */
  join(room) {
    this.current && this.current.emit(this.setting.events.join, room)
    return this
  }

  /**
   * leave event channel
   *
   * @date 2022-10-05
   * @param {object} room
   */
  leave(room) {
    this.current && this.current.emit(this.setting.events.leave, room)
    return this
  }
}
